import {ReactElement} from "react";
import {StyledBoxColumn, StyledBoxRow, StyledHeadingVariant} from "@/shared/StyledComponents";
import {Button, Typography, useMediaQuery, useTheme} from "@mui/material";
import {PD_LG, PD_SM, PD_XLG, PD_XLG2, PD_XLG3} from "@/shared/dimens";
import {HighlightSectionData} from "../../types";

export function HighlightSection(props: { data: HighlightSectionData }): ReactElement {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const md = useMediaQuery(theme.breakpoints.up("md"));

  const imagePane = <div style={{flex: "1 0 42%", minHeight: sm ? 480 : 280, position: "relative"}}>
    <img
      src={props.data.imageUrl}
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        objectFit: "cover",
        objectPosition: "center",
        display: "block",
      }}/>
  </div>;

  const textPane = <div style={{
    flex: "1 0 42%",
    display: "flex",
    alignItems: "center",
    padding: md ? `${PD_XLG3}px ${PD_XLG2}px` : sm ? `${PD_XLG2}px` : `${PD_XLG}px ${PD_LG}px`,
  }}>
    <StyledBoxColumn style={{gap: PD_XLG, maxWidth: 520}}>
      <StyledBoxColumn style={{gap: PD_LG}}>
        {props.data.eyebrow
          ? <Typography
            variant="overline"
            style={{letterSpacing: 3, fontWeight: "bold", color: theme.palette.primary.main}}>
            {props.data.eyebrow}
          </Typography>
          : null}
        {props.data.title
          ? <StyledHeadingVariant default_={2}>
            {props.data.title}
          </StyledHeadingVariant>
          : null}
        {props.data.text
          ? <Typography style={{opacity: 0.65, lineHeight: 1.8}}>
            {props.data.text}
          </Typography>
          : null}
      </StyledBoxColumn>
      {props.data.links?.length > 0
        ? <StyledBoxRow style={{flexWrap: "wrap", gap: PD_SM}}>
          {props.data.links.map((link, i) =>
            <Button
              key={i}
              href={link.url}
              variant={i === 0 ? "contained" : "outlined"}>
              {link.text}
            </Button>
          )}
        </StyledBoxRow>
        : null}
    </StyledBoxColumn>
  </div>;

  const imageLeft = props.data.imagePosition === "left";

  return <div style={{display: "flex", flexWrap: "wrap", width: "100%"}}>
    {imageLeft
      ? <>{imagePane}{textPane}</>
      : <>{textPane}{imagePane}</>}
  </div>;
}
